import DatabasesResource from 'remote/resources/databases';

const clearDatabase = (dbid: string) => DatabasesResource.clear(dbid);

export default clearDatabase;
